<template>
  <v-toolbar elevation="1" density="compact" class="user-toolbar-container pr-2">
    <settings-menu />
    <AvatarMenu class="ml-2" avatar-color="primary" :user-info="userData"></AvatarMenu>
  </v-toolbar>
</template>

<script setup lang="ts">
import { ref } from "vue";
import SettingsMenu from "./SettingsMenu/SettingsMenu.vue";
import { AvatarMenu } from "@itemis-solutions/platform-web-components";
import { useUserStore } from "../Authentication/store/userStore";

const userStore = useUserStore();
const userData = ref(userStore.getUserInfo);
</script>

<style scoped>
.user-toolbar-container {
  width: fit-content;
  padding: 0px;
  position: absolute;
  top: 0px;
  right: 10px;
  z-index: 1;
}

@media (max-width: 374.98px) {
  .user-toolbar-container {
    top: 55px;
  }
}
</style>
